import axios, { AxiosResponse } from 'axios';
import config from 'client/config';

export const getFeatures = (featureName: string) => {
  return axios
    .get(config.cdnUrl + `/features/${featureName}`)
    .then((response: AxiosResponse) => response.data);
};
